// ── Central API config ─────────────────────────────────────────────────────
// Defaults to the deployed backend. To point at a locally-running Functions
// host instead, DON'T edit this file — create `frontend/.env.local` with:
//
//     REACT_APP_API_HOST=http://localhost:7071
//
// then restart `npm start`.
//
// IMPORTANT: `.env.local` being gitignored does NOT make it deploy-safe.
// Create React App reads it for PRODUCTION builds as well (it's skipped only
// for NODE_ENV=test — see react-scripts/config/env.js), so `npm run build` on
// a machine that has one will bake localhost into the bundle and every user's
// browser will call their own port 7071. That shipped once.
//
// What actually makes deploys safe is `deploy.ps1`: it sets
// REACT_APP_API_HOST as a real environment variable before building, which
// takes precedence over any .env* file, and then refuses to upload a bundle
// containing a localhost URL. Build via that script, not `npm run build`.
const API_HOST = process.env.REACT_APP_API_HOST
    || 'https://soulflower-backend-haggfkbab6fxbqfy.centralindia-01.azurewebsites.net';

export const API_BASE = `${API_HOST}/api`;

// ── Web Push ────────────────────────────────────────────────────────────────
// VAPID public key — not secret, safe to ship in the built bundle (that's
// the point of the VAPID key pair). Matching private key lives only in the
// soulflower-backend Function App's application settings.
export const VAPID_PUBLIC_KEY = 'BAA_IyzjSN9gJCMna6h2MlCAo6KmHHhuzVaE0oX4fmJinEfN3ssg1MDnqbijHGXuAFEGl1wgcNVXR4-bpSvRS7w';